import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../src/style/css/feather.css";
import "../src/index.scss";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import "../src/style/icon/boxicons/boxicons/css/boxicons.min.css";
import "../src/style/icon/weather/weathericons.css";
import "../src/style/icon/typicons/typicons.css";
import "../node_modules/@fortawesome/fontawesome-free/css/fontawesome.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.min.css";
import "../src/style/icon/ionic/ionicons.css";
import "../src/style/icon/tabler-icons/webfont/tabler-icons.css";
import ALLRoutes from "./feature-module/router/router";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.min.js";
import { Buffer } from "buffer";
import { AuthProvider } from "./feature-module/auth/AuthContext";

(globalThis as any).Buffer = Buffer;

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  // <React.StrictMode>
  //   <Provider store={store}>
  //     {/* <BrowserRouter basename={base_path}> */}
  //     <BrowserRouter>
  //       <AuthProvider>
  //         <ALLRoutes />
  //       </AuthProvider>
  //     </BrowserRouter>
  //   </Provider>
  // </React.StrictMode>,
  <Provider store={store}>
    {/* <BrowserRouter basename={base_path}> */}
    <BrowserRouter>
      <AuthProvider>
        <ALLRoutes />
      </AuthProvider>
    </BrowserRouter>
  </Provider>,
);
